export default "__VITE_ASSET__CJLm$nCn__"